const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const JSON_HEADERS = { 'Content-Type': 'application/json' };

const handleResponse = async (response) => {
  let data = null;
  try {
    data = await response.json();
  } catch (_) {
    data = null;
  }
  if (!response.ok) {
    const message = data?.detail || data?.message || 'Chat request failed';
    throw new Error(message);
  }
  return data;
};

export const sendChatMessage = async ({ message, conversationId, accessToken, forceIntent }) => {
  const headers = {
    ...JSON_HEADERS,
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };

  const payload = {
    message,
    conversation_id: conversationId || undefined,
    ...(forceIntent ? { force_intent: forceIntent } : {}),
  };

  // eslint-disable-next-line no-console
  console.log('POST /chat payload:', payload);

  const response = await fetch(`${API_BASE}/chat`, {
    method: 'POST',
    headers,
    credentials: 'include',
    body: JSON.stringify(payload),
  });
  return handleResponse(response);
};
